import {
	InventoryItemsViewModal,
	InventoryUnitsViewModal,
} from "../../../../../pages/Inventory/view";
import { ItemsSliderModal } from "../../../../../pages/Items/view/";
import { getItemDetails } from "../../../../../pages/Items/api/itemsApi";
import OrderDetailsModal from "../../../../../pages/Orders/view/OrderView/OrderDetailsModal";
import { ApprovalsModal } from "../../../../../pages/Orders/view/ApprovalView";
import { VendorSliderModal } from "../../../../../pages/VendorItems";

type RenderModalContentProps = {
	pageTitle: string;
	isModalOpen: boolean;
	closeModal: () => void;
	data: any;
	hostName: string;
	activeRowStatus: any;
	updateRowData: (uuid: string, key: string, newValue: any) => void;
	isPathnameInventory_Items: boolean;
};

type ModalCondition = {
	field?: string;
	values?: any[];
	customCheck?: (props: any) => boolean;
};

type ModalConfig = {
	component: React.ComponentType<any>;
	props?: any;
	condition?: ModalCondition;
};

type PageModalConfig = {
	[pageTitle: string]: ModalConfig[];
};

type ClientModalConfig = {
	[clientName: string]: PageModalConfig;
};

export const modalConfig: ClientModalConfig = {
	COMPASS: {
		Inventory: [
			{
				component: InventoryUnitsViewModal,
				props: { makeApiCall: getItemDetails, isOpen: true },
				condition: {
					field: "isPathnameInventory_Items",
					values: [true],
				},
			},
		],
		Items: [
			{
				component: ItemsSliderModal,
				props: { makeApiCall: getItemDetails },
			},
		],
		"Vendor Items": [
			{
				component: VendorSliderModal,
			},
		],
		Orders: [
			{
				component: ApprovalsModal,
				condition: {
					field: "activeRowStatus.data.status",
					values: [
						"pendingInitialApproval",
						"pendingApproval",
						"Pending Approval",
						"Pending Initial Approval",
						"unknown",
						undefined,
					],
				},
			},
			{
				component: OrderDetailsModal,
			},
		],
	},
	COMPASSCANADA: {
		Inventory: [
			{
				component: InventoryUnitsViewModal,
				props: { makeApiCall: getItemDetails, isOpen: true },
				condition: {
					field: "isPathnameInventory_Items",
					values: [true],
				},
			},
		],
		Items: [
			{
				component: ItemsSliderModal,
				props: { makeApiCall: getItemDetails },
			},
		],
		"Vendor Items": [
			{
				component: VendorSliderModal,
			},
		],
		Orders: [
			{
				component: ApprovalsModal,
				condition: {
					field: "activeRowStatus.data.status",
					values: [
						"pendingInitialApproval",
						"pendingApproval",
						"Pending Approval",
						"Pending Initial Approval",
						"unknown",
						undefined,
					],
				},
			},
			{
				component: OrderDetailsModal,
			},
		],
	},
	QUAD: {
		Inventory: [
			{
				component: InventoryUnitsViewModal,
				props: { makeApiCall: getItemDetails, isOpen: true },
				condition: {
					field: "isPathnameInventory_Items",
					values: [true],
				},
			},
		],
		Items: [
			{
				component: ItemsSliderModal,
				props: { makeApiCall: getItemDetails },
			},
		],
		"Vendor Items": [
			{
				component: VendorSliderModal,
			},
		],
		Orders: [
			{
				component: ApprovalsModal,
				condition: {
					field: "activeRowStatus.data.status",
					values: [
						"pendingApproval",
						"Pending Approval",
						"unknown",
						undefined,
					],
				},
			},
			{
				component: OrderDetailsModal,
			},
		],
	},
	// Add other clients with their specific configurations
	DEFAULT: {
		Inventory: [
			{
				component: InventoryUnitsViewModal,
				props: { makeApiCall: getItemDetails, isOpen: true },
				condition: {
					field: "isPathnameInventory_Items",
					values: [true],
				},
			},
		],
		Items: [
			{
				component: ItemsSliderModal,
				props: { makeApiCall: getItemDetails },
			},
		],
		"Vendor Items": [
			{
				component: VendorSliderModal,
			},
		],
		Orders: [
			{
				component: OrderDetailsModal,
			},
		],
	},
};
const getNestedValue = (obj: any, path: string) => {
	return path.split(".").reduce((acc, part) => acc?.[part], obj);
};

export const renderModalContent = ({
	pageTitle,
	isModalOpen,
	closeModal,
	data,
	hostName,
	activeRowStatus,
	updateRowData,
	isPathnameInventory_Items = false,
}: RenderModalContentProps) => {
	const clientConfig = modalConfig[hostName] || modalConfig.DEFAULT;
	const pageConfig = clientConfig[pageTitle];

	if (!pageConfig) return null;

	const context = {
		isPathnameInventory_Items,
		activeRowStatus,
		data,
	};

	// Find the first matching modal configuration
	for (const modalDef of pageConfig) {
		if (!modalDef.condition) {
			// No condition, use this modal
			const ModalComponent = modalDef.component;
			return (
				<ModalComponent
					isOpen={isModalOpen}
					onClose={closeModal}
					parentData={data}
					updateRowData={updateRowData}
					{...modalDef.props}
				/>
			);
		}

		// Check condition
		const { field, values, customCheck } = modalDef.condition;

		if (customCheck && customCheck(context)) {
			const ModalComponent = modalDef.component;
			return (
				<ModalComponent
					isOpen={isModalOpen}
					onClose={closeModal}
					parentData={data}
					updateRowData={updateRowData}
					{...modalDef.props}
				/>
			);
		}

		if (field && values) {
			const fieldValue = getNestedValue(context, field);

			if (values.includes(fieldValue)) {
				const ModalComponent = modalDef.component;
				return (
					<ModalComponent
						isOpen={isModalOpen}
						onClose={closeModal}
						parentData={data}
						updateRowData={updateRowData}
						{...modalDef.props}
					/>
				);
			}
		}
	}

	return null;
};
